export default "__VITE_ASSET__gjUND9HL__"